import React, { useState } from 'react';
import { Mail, Phone, MessageSquare, Send } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import './Contact.css';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    toast({
      title: "Message envoyé !",
      description: "Nous vous répondrons dans les plus brefs délais.",
    });
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const whatsappNumber = '33786064462'; // Format international
  const whatsappMessage = encodeURIComponent('Bonjour, je souhaite obtenir plus d\'informations sur vos produits.');

  return (
    <div className="contact">
      <div className="contact-hero">
        <div className="container">
          <h1 className="heading-primary">Contactez-nous</h1>
          <p className="contact-description">
            Une question ? Un devis ? N'hésitez pas à nous contacter
          </p>
        </div>
      </div>

      <div className="contact-content section-padding">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-info">
              <h2 className="heading-tertiary">Nos Coordonnées</h2>
              <p className="info-text">
                Notre équipe est à votre disposition pour répondre à toutes vos questions.
              </p>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">
                    <Mail size={24} />
                  </div>
                  <div className="method-info">
                    <h4>Email</h4>
                    <a href="mailto:phoenixnegoce@gmail.com">phoenixnegoce@gmail.com</a>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">
                    <Phone size={24} />
                  </div>
                  <div className="method-info">
                    <h4>Téléphone</h4>
                    <a href="tel:0786064462">07 86 06 44 62</a>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon whatsapp-icon">
                    <MessageSquare size={24} />
                  </div>
                  <div className="method-info">
                    <h4>WhatsApp</h4>
                    <a
                      href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="whatsapp-link"
                    >
                      Envoyer un message
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <form onSubmit={handleSubmit} className="contact-form">
                <h2 className="heading-tertiary">Envoyez-nous un message</h2>

                <div className="form-group">
                  <label htmlFor="name">Nom complet *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Votre nom"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="votre@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Téléphone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="06 12 34 56 78"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Votre message..."
                  />
                </div>

                <button type="submit" className="btn-primary btn-submit">
                  <Send size={20} />
                  Envoyer le message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;